import {
    getLogin,
    permissionList,
    getEngineerList,
    getSectionList,
    getChannelsList,
    controlStart,
    controlEnd
} from "@/api/api";
import Player, {
    Events
} from "xgplayer";
import FlvPlugin from 'xgplayer-flv';
import HlsPlugin from 'xgplayer-hls';
import "xgplayer/dist/index.min.css";

export default {
    name: "yeMast",
    data() {
        return {
            player: null,
            ezuikitFlvPlayer: null,
            ezuikitHlsPlayer: null,
            ezuikitRecPlayer: null,
            nativeVideo: null, // 原生video引用
            engineerListData: [],
            engineeringId: "",
            sectionListData: [],
            sectionId: "",
            serverData: [],
            sideList: [],
            videoName: "",
            videoData: "",
            hasUrl: false,
            isVideoLoading: false,
            playFlag: true,
            changeVideoNow: false,
            fullFlag: false,
            controlMaxFlag: false,
            controlButtonFlag: false,
            miniInfo: {},
            maxInfo: {},
            miniBar: {},
            maxBar: {},
            videoFull: null,
            barFull: null,
            SD: "",
            scrollTop: "",
            oldScrollTop: "",
            baseUrl: "https://jk-xs.yemast.com:8006",
            direction: "",
            canStop: false,
            nowStop: false,

            // 选择高清或标清
            qualityData: [{
                id: 1,
                name: "高清"
            },
            {
                id: 2,
                name: "标清"
            },
            {
                id: 3,
                name: "回放"
            }
            ],
            quality: 1,

            // 萤石云回放时间
            playbackPickerVisible: false,
            customRange: [],
            playbackStart: "",
            playbackEnd: "",
            startTime: "",
            stopTime: "",
            playbackRequestId: 0,

            // 移动端底部选择器
            pickerVisible: false,
            pickerType: "",
            pickerKeyword: "",
            // 实际用于过滤的关键字（避开输入法拼写过程误过滤）
            pickerFilterKeyword: "",
            pickerComposing: false,
            _pageScrollTop: 0,
            _nativePlayToken: 0,

            // iOS兼容性相关
            iosVersion: null,
            isIOS: false,
            isWechat: false,
        };
    },
    computed: {
        engineeringLabel() {
            const item = this.engineerListData.find(i => i.id === this.engineeringId);
            return item ? item.engineeringName : "请选择工程";
        },
        sectionLabel() {
            const item = this.sectionListData.find(i => i.id === this.sectionId);
            return item ? item.sectionName : "请选择标段";
        },
        deviceLabel() {
            if (!this.videoName) {
                return "请选择设备";
            }
            if (this.videoData && this.videoData.channelName) {
                return this.videoData.channelName;
            }
            return "请选择设备";
        },
        pickerTitle() {
            const map = {
                engineering: "选择工程",
                section: "选择标段",
                device: "选择设备",
                quality: "选择清晰度"
            };
            return map[this.pickerType] || "";
        },
        pickerSearchPlaceholder() {
            const map = {
                engineering: "搜索工程名称",
                section: "搜索标段名称",
                device: "搜索设备/地点名称"
            };
            return map[this.pickerType] || "搜索";
        },
        qualityLabel() {
            const item = this.qualityData.find(i => i.id === this.quality);
            return item ? item.name : "清晰度";
        },
        qualityOptions() {
            const platform = this.videoData ? this.videoData.platform : "";
            // H5LIV 回放暂时关闭，不展示「回放」
            if (platform === "H5LIV") {
                return this.qualityData.filter(item => item.id !== 3);
            }
            return this.qualityData;
        },
        filteredEngineerList() {
            const list = this.engineerListData || [];
            const keyword = (this.pickerFilterKeyword || "").toLowerCase().trim();
            if (!keyword) return list;
            return list.filter(item => {
                const name = (item.engineeringName || "").toLowerCase();
                return name.indexOf(keyword) > -1;
            });
        },
        filteredSectionList() {
            const list = this.sectionListData || [];
            const keyword = (this.pickerFilterKeyword || "").toLowerCase().trim();
            if (!keyword) return list;
            return list.filter(item => {
                const name = (item.sectionName || "").toLowerCase();
                return name.indexOf(keyword) > -1;
            });
        },
        filteredSideList() {
            const list = this.sideList || [];
            const keyword = (this.pickerFilterKeyword || "").toLowerCase().trim();
            const result = [];
            list.forEach((group, groupIndex) => {
                const place = group.place || "";
                const placeName = place.toLowerCase();
                const placeMatched = !!(keyword && placeName.indexOf(keyword) > -1);
                const sourceChannels = group.channelList || [];
                const channels = [];
                for (let childIndex = 0; childIndex < sourceChannels.length; childIndex++) {
                    const child = sourceChannels[childIndex];
                    if (!keyword || placeMatched) {
                        // 地点命中：保留该组全部通道，避免筛选后“丢数据”
                        channels.push(Object.assign({}, child, { childIndex }));
                        continue;
                    }
                    const channelName = (child.channelName || "").toLowerCase();
                    const deviceName = (child.name || "").toLowerCase();
                    if (channelName.indexOf(keyword) > -1 || deviceName.indexOf(keyword) > -1) {
                        channels.push(Object.assign({}, child, { childIndex }));
                    }
                }
                if (channels.length) {
                    result.push({
                        place,
                        groupIndex,
                        channelList: channels
                    });
                }
            });
            return result;
        }
    },
    created() {
        this.loginMain();
        this.detectDevice();
        // 提前预加载播放器脚本，缩短首次起播等待
        this.preloadPlayerAssets();
    },
    mounted() { },
    watch: {
        engineeringId(newVal, oldVal) {
            this.sectionList();
        },
        sectionId() {
            this.videoName = "";
            this.getImg();
        },
        canStop(newVal, oldVal) {
            if (newVal == true && this.nowStop == true) {
                this.getcontrolEnd();
            }
        },
        nowStop(newVal, oldVal) {
            if (newVal == true && this.canStop == true) {
                this.getcontrolEnd();
            }
        }
    },
    methods: {
        // ========== 移动端选择器 ==========
        openPicker(type) {
            this.pickerType = type;
            this.pickerKeyword = "";
            this.pickerFilterKeyword = "";
            this.pickerComposing = false;
            this.pickerVisible = true;
            this.lockPageScroll();
            if (type !== "quality") {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.focusPickerSearch();
                    }, 300);
                });
            }
        },
        closePicker() {
            this.pickerVisible = false;
            this.pickerKeyword = "";
            this.pickerFilterKeyword = "";
            this.pickerComposing = false;
            if (!this.playbackPickerVisible) {
                this.unlockPageScroll();
            }
        },
        lockPageScroll() {
            const scrollTop = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop
                || 0;
            this._pageScrollTop = scrollTop;
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.left = "0";
            document.body.style.right = "0";
            document.body.style.top = `-${scrollTop}px`;
            document.body.style.width = "100%";
        },
        unlockPageScroll() {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.body.style.top = "";
            document.body.style.width = "";
            const top = this._pageScrollTop || 0;
            window.scrollTo(0, top);
            this._pageScrollTop = 0;
        },
        focusPickerSearch() {
            const comp = this.$refs.pickerSearchInput;
            if (!comp) return;
            try {
                if (typeof comp.focus === "function") {
                    comp.focus();
                }
            } catch (e) { }
            const input = comp.$el && comp.$el.querySelector("input");
            if (input) {
                input.focus();
            }
        },
        onPickerSearchInput(val) {
            const next = val == null ? "" : String(val);
            this.pickerKeyword = next;
            // 输入法拼写过程中不更新过滤，避免列表被拼音临时“筛空”
            if (!this.pickerComposing) {
                this.pickerFilterKeyword = next.trim();
            }
        },
        onPickerSearchCompositionEnd(e) {
            this.pickerComposing = false;
            const val = e && e.target ? e.target.value : this.pickerKeyword;
            const next = val == null ? "" : String(val);
            this.pickerKeyword = next;
            this.pickerFilterKeyword = next.trim();
        },
        selectEngineering(id) {
            this.engineeringId = id;
            this.closePicker();
        },
        selectSection(id) {
            this.sectionId = id;
            this.closePicker();
        },
        selectDevice(val) {
            this.videoName = val;
            this.changeVideo(val);
            this.closePicker();
        },
        selectQuality(id) {
            if (id === this.quality) {
                this.closePicker();
                // 已在「回放」时再次选择：萤石云重新弹出时间
                if (id === 3) {
                    const platform = this.videoData ? this.videoData.platform : "";
                    // H5LIV 回放暂时关闭
                    // if (platform === "H5LIV") {
                    //     this.startH5LivPlayback();
                    // } else {
                    //     this.openPlaybackPicker();
                    // }
                    if (platform !== "H5LIV") {
                        this.openPlaybackPicker();
                    }
                }
                return;
            }
            this.closePicker();
            this.changeQuality(id);
        },

        // ========== 设备检测 ==========
        detectDevice() {
            const ua = navigator.userAgent.toLowerCase();
            this.isIOS = /iphone|ipad|ipod/.test(ua);
            this.isWechat = /micromessenger/.test(ua);

            if (this.isIOS) {
                const match = ua.match(/os (\d+)_(\d+)/);
                if (match) {
                    this.iosVersion = parseFloat(`${match[1]}.${match[2]}`);
                } else {
                    this.iosVersion = 15;
                }
            }

            console.log('设备检测:', {
                isIOS: this.isIOS,
                iosVersion: this.iosVersion,
                isWechat: this.isWechat,
                UA: navigator.userAgent
            });
        },

        // 判断是否在微信小程序环境中
        isWechatMiniProgram() {
            const ua = navigator.userAgent.toLowerCase();
            if (typeof window.__wxjs_environment !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
                return true;
            }
            if (ua.indexOf('miniprogram') > -1 || ua.indexOf('micromessenger') > -1) {
                return true;
            }
            return false;
        },

        // 判断是否为苹果设备（iOS/macOS）
        isAppleDevice() {
            const ua = navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod|macintosh/.test(ua);
        },

        // iOS 18 以下：低版本，HLS 走 Safari 原生 video
        // iOS 18 及以上：高版本，HLS 走 ezuikit-hls
        isLowVersionIOS() {
            if (!this.isIOS) return false;
            if (this.iosVersion === null) return true;
            return this.iosVersion < 18;
        },

        // 判断链接是否为 HLS（.m3u8）
        isHlsUrl(url) {
            if (!url) return false;
            const path = url.toLowerCase().split('?')[0];
            return path.includes('.m3u8');
        },

        // 萤石 openlive 地址（Safari 原生 video 常报 MEDIA_ERR_SRC_NOT_SUPPORTED / code 4）
        isYs7OpenliveUrl(url) {
            if (!url) return false;
            return /open\.ys7\.com/i.test(url) && /openlive/i.test(url);
        },

        isReplayMode() {
            return Number(this.quality) === 3;
        },

        isPureEzvizDevice() {
            if (!this.videoData) return true;
            return this.videoData.platform !== "H5LIV";
        },

        isEzvizCloudReplay() {
            return this.isPureEzvizDevice() && this.isReplayMode();
        },

        isEzopenUrl(url) {
            if (!url) return false;
            return /^ezopen:/i.test(String(url).trim());
        },

        getEzvizDeviceCode() {
            if (!this.videoData) return "";
            const d = this.videoData;
            return (
                d.validateCode ||
                d.code ||
                d.deviceCode ||
                d.verificationCode ||
                ""
            );
        },

        formatYs7TimeToEzopen(timeStr) {
            if (!timeStr) return "";
            const text = String(timeStr).trim();
            if (/^\d{14}$/.test(text)) return text;
            const m = text.match(
                /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/
            );
            if (m) {
                return `${m[1]}${m[2]}${m[3]}${m[4]}${m[5]}${m[6]}`;
            }
            const digits = text.replace(/\D/g, "");
            return digits.length >= 14 ? digits.slice(0, 14) : digits;
        },

        assertEzvizPlaybackUrl(url) {
            const normalized = this.normalizeLiveUrl(url);
            if (!normalized) {
                throw new Error("获取回放地址失败：地址为空");
            }
            if (this.isEzopenUrl(normalized)) {
                return normalized;
            }
            if (this.isHlsUrl(normalized) && this.isYs7OpenliveUrl(normalized)) {
                throw new Error(
                    "获取到直播 HLS 地址，萤石回放请使用 ezopen 协议（protocol=1）"
                );
            }
            throw new Error("回放地址格式不支持，请确认设备录像与取流参数");
        },

        stripVoAudioCodecs(text) {
            if (!text || typeof text !== "string") return text;
            if (!/_vo\.m3u8|chuncklist_vo/i.test(text)) return text;
            return text.replace(/CODECS="([^"]*)"/gi, (match, codecs) => {
                const next = String(codecs)
                    .split(/[ ,]+/)
                    .filter(c => c && !/^mp4a/i.test(c))
                    .join(",");
                return `CODECS="${next}"`;
            });
        },

        // 仅回放模式使用（不影响直播 xgplayer 配置）
        getReplayHlsOptions(url) {
            const voParse = { onPreM3U8Parse: text => this.stripVoAudioCodecs(text) };
            return {
                minSegmentsStartPlay: 1,
                preloadTime: 12,
                bufferBehind: 30,
                maxBufferLength: 120,
                loadTimeout: 20000,
                manifestLoadTimeout: 20000,
                retryCount: 3,
                retryDelay: 500,
                pollRetryCount: 3,
                useLowLatency: false,
                mseLowLatency: false,
                preferMMS: false,
                preferMMSStreaming: false,
                ...voParse
            };
        },

        // 规范化直播地址（解码 HTML 实体）
        normalizeLiveUrl(url) {
            if (!url) return '';
            return String(url).replace(/&amp;/g, '&').trim();
        },

        // H5LIV 回放：仅使用列表下发的 backUrl（通道优先，否则设备级）
        getBackUrl() {
            if (!this.videoData) return "";
            const serial = this.videoData.serialNumber;
            const channelNo = this.videoData.channelNo;
            for (let i = 0; i < (this.sideList || []).length; i++) {
                const group = this.sideList[i];
                if (group.serialNumber !== serial) continue;
                const channels = group.channelList || [];
                for (let j = 0; j < channels.length; j++) {
                    const ch = channels[j];
                    if (String(ch.channelNo) === String(channelNo) && ch.backUrl) {
                        return ch.backUrl;
                    }
                }
                if (group.backUrl) return group.backUrl;
            }
            return this.videoData.backUrl || "";
        },

        startH5LivPlayback() {
            // H5LIV 回放暂时关闭
            return false;
            // const backUrl = this.normalizeLiveUrl(this.getBackUrl());
            // if (!backUrl) {
            //     this.$message.warning("暂无回放地址");
            //     return false;
            // }
            // if (!this.isHlsUrl(backUrl)) {
            //     this.$message.warning("回放地址不是 m3u8，请检查列表 backUrl");
            //     return false;
            // }
            // this.quality = 3;
            // this.showVideoLoading();
            // this.hasUrl = false;
            // this.destroyPlayer();
            // this.startPlayback(backUrl);
            // return true;
        },

        ensurePlaybackRangeDefaults() {
            const pad = n => String(n).padStart(2, "0");
            const fmt = d =>
                `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
                    d.getHours()
                )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            if (this.startTime && this.stopTime) {
                this.playbackStart = this.startTime;
                this.playbackEnd = this.stopTime;
                this.customRange = [this.startTime, this.stopTime];
                return;
            }
            if (this.customRange && this.customRange.length === 2) {
                this.startTime = this.customRange[0];
                this.stopTime = this.customRange[1];
                this.playbackStart = this.customRange[0];
                this.playbackEnd = this.customRange[1];
                return;
            }
            const end = new Date();
            const start = new Date(end.getTime() - 60 * 60 * 1000);
            this.playbackStart = fmt(start);
            this.playbackEnd = fmt(end);
            this.customRange = [this.playbackStart, this.playbackEnd];
            this.startTime = this.playbackStart;
            this.stopTime = this.playbackEnd;
        },

        openPlaybackPicker() {
            this.ensurePlaybackRangeDefaults();
            this.playbackPickerVisible = true;
            this.lockPageScroll();
        },

        closePlaybackPicker() {
            this.playbackPickerVisible = false;
            if (!this.pickerVisible) {
                this.unlockPageScroll();
            }
        },

        async confirmPlaybackRange() {
            if (!this.playbackStart || !this.playbackEnd) {
                this.$message.warning("请选择开始和结束时间");
                return;
            }
            if (new Date(this.playbackStart).getTime() >= new Date(this.playbackEnd).getTime()) {
                this.$message.warning("结束时间须晚于开始时间");
                return;
            }
            this.startTime = this.playbackStart;
            this.stopTime = this.playbackEnd;
            this.customRange = [this.playbackStart, this.playbackEnd];
            this.closePlaybackPicker();
            await this.fetchPlaybackStream();
        },

        async fetchPlaybackStream() {
            if (!this.videoData) return;
            if (this.videoData.platform === "H5LIV") {
                // H5LIV 回放暂时关闭
                // this.startH5LivPlayback();
                return;
            }
            const { accessToken, serialNumber, channelNo } = this.videoData;
            if (!accessToken || !serialNumber || channelNo === undefined || channelNo === null || channelNo === "") {
                this.$message.warning("回放参数不完整，请重新选择设备");
                return;
            }
            if (!this.startTime || !this.stopTime) {
                this.$message.warning("请选择回放时间范围");
                return;
            }
            const requestId = ++this.playbackRequestId;
            this.showVideoLoading();
            this.hasUrl = false;
            this.destroyPlayer();
            try {
                const url = await this.fetchYs7PlaybackUrl(
                    accessToken,
                    serialNumber,
                    channelNo,
                    this.startTime,
                    this.stopTime
                );

                if (requestId !== this.playbackRequestId) return;
                // 先标记回放，避免 getBestPlugin / createPlayer 按直播追帧
                this.quality = 3;
                this.videoData.videoUrl = url;
                await this.preloadEzvizReplayAssets();
                this.startPlayback(url);
            } catch (e) {
                if (requestId !== this.playbackRequestId) return;
                console.error("萤石回放取流异常", e);
                this.hideVideoLoading();
                this.$message.error((e && e.message) || "回放接口请求失败，请稍后重试");
            }
        },

        // 获取 H5LIV 直播地址（channel 上没有时从设备项取）
        getLivUrl() {
            if (!this.videoData) return '';
            if (this.videoData.livurl) {
                return this.videoData.livurl;
            }
            const device = this.sideList.find(item => {
                return item.serialNumber == this.videoData.serialNumber;
            });
            return device ? device.livurl : '';
        },

        // 非 H5LIV 萤石 HLS 接口：iOS 按系统版本选择播放方案
        getIosHlsPlugin() {
            // 低版本必须原生优先（含 openlive）；失败再静默降级 ezuikit
            // 低版本直接走 ezuikit 常出现 loading 结束无画面
            if (this.isLowVersionIOS()) {
                console.log('→ iOS < 18（低版本）+ HLS = nativeHls');
                return 'nativeHls';
            }
            console.log('→ iOS >= 18（高版本）+ HLS = ezuikitHls');
            return 'ezuikitHls';
        },

        // ========== 获取最优播放插件 ==========
        getBestPlugin() {
            const videoUrl = this.videoData ? this.videoData.videoUrl : '';
            const isH5LIV = this.videoData && this.videoData.platform == 'H5LIV';
            const isHls = this.isHlsUrl(videoUrl);
            const isOpenlive = this.isYs7OpenliveUrl(videoUrl);

            // 纯萤石云回放：ezopen + EZUIKit mobileRec（全机型统一，不走 HLS/FLV 直链）
            if (this.isEzvizCloudReplay()) {
                console.log('→ 萤石云回放 = ezuikitRec (mobileRec)');
                return 'ezuikitRec';
            }

            console.log('getBestPlugin 判断:', {
                isIOS: this.isIOS,
                iosVersion: this.iosVersion,
                isLowIOS: this.isLowVersionIOS(),
                platform: this.videoData ? this.videoData.platform : 'videoData未就绪',
                isHls,
                isOpenlive,
                videoUrl
            });

            if (this.isIOS) {
                if (isH5LIV) {
                    if (!isHls) {
                        console.log('→ iOS + H5LIV(FLV) = ezuikitFlv');
                        return 'ezuikitFlv';
                    }
                    // 低版本：全部 m3u8（含 openlive）先原生，失败再降级
                    if (this.isLowVersionIOS()) {
                        console.log('→ iOS < 18 + H5LIV(m3u8/openlive) = nativeHls');
                        return 'nativeHls';
                    }
                    // 高版本：m3u8 / openlive 走 ezuikit
                    console.log('→ iOS >= 18 + H5LIV(m3u8/openlive) = ezuikitHls');
                    return 'ezuikitHls';
                }
                return this.getIosHlsPlugin();
            }

            // 非 iOS：H5LIV 且 livurl 为 FLV 走 flvPlugin，其余走 hlsPlugin
            if (isH5LIV && !isHls) {
                console.log('→ 非iOS + H5LIV(FLV) = flvPlugin');
                return 'flvPlugin';
            }
            console.log('→ 非iOS + HLS = hlsPlugin');
            return 'hlsPlugin';
        },

        // ========== 创建播放器 ==========
        createPlayer(videoUrl, pluginType) {
            // 销毁旧播放器（统一在这里销毁，避免 startPlayback 再销毁一次）
            this.destroyPlayer();

            const container = document.getElementById('video-container');
            if (!container) {
                console.error('容器不存在');
                return;
            }

            const boxSize = this.getVideoBoxSize(container);

            // ========== iOS 低版本 HLS：Safari 原生 video ==========
            if (pluginType === 'nativeHls') {
                this.createNativePlayer(videoUrl, container);
                return;
            }

            // ========== iOS 使用 ezuikit 插件 ==========
            if (pluginType === 'ezuikitFlv') {
                this.loadEzuikitFlv(videoUrl, boxSize);
                return;
            }

            // ========== iOS 高版本 HLS：ezuikit-hls ==========
            if (pluginType === 'ezuikitHls') {
                this.loadEzuikitHls(videoUrl, boxSize);
                return;
            }

            // ========== 纯萤石云回放：EZUIKit mobileRec ==========
            if (pluginType === 'ezuikitRec') {
                this.loadEzvizReplayPlayer(videoUrl, boxSize);
                return;
            }

            // ========== 安卓使用 xgplayer 插件 ==========
            const replayMode = this.isReplayMode();
            // 构建播放器配置（使用容器实测宽高，避免 100% 高度塌陷）
            const config = {
                id: "video-container",
                url: videoUrl,
                width: boxSize.width,
                height: boxSize.height,
                autoplay: true,
                isLive: !replayMode,
                controls: true,
                lang: "zh-cn",
                cssFullscreen: false,
                playsinline: this.isAppleDevice(),
                "x5-video-player-type": "h5",
                "x5-video-orientation": "portraint",
            };

            // 根据插件类型添加配置
            if (pluginType === 'flvPlugin') {
                config.plugins = [FlvPlugin];
                config.flvConfig = {
                    enableWorker: true,
                    enableStashBuffer: false,
                    stashInitialSize: 128,
                };
            } else if (pluginType === 'hlsPlugin') {
                config.plugins = [HlsPlugin];
                if (replayMode) {
                    config.hls = this.getReplayHlsOptions(videoUrl);
                } else {
                    // 直播起播优化：更短缓冲、低延迟，不改变解码插件本身
                    config.hlsConfig = {
                        enableWorker: true,
                        maxBufferLength: 4,
                        maxMaxBufferLength: 8,
                        lowLatencyMode: true,
                        fragLoadingMaxRetry: 5,
                        manifestLoadingMaxRetry: 5,
                        levelLoadingMaxRetry: 5,
                        fragLoadingRetryDelay: 500,
                        enableWebVTT: false,
                        enableCEA708Captions: false,
                    };
                }
            }

            // 创建播放器
            try {
                this.player = new Player(config);
                console.log(`xgplayer ${pluginType} 播放器创建成功`, boxSize);

                // 监听错误
                this.player.on(Events.ERROR, (e) => {
                    console.error('播放器错误:', e);
                    this.hideVideoLoading();
                    if (e.code === 5) {
                        this.handlePlaybackError(videoUrl);
                    }
                });

                this.player.on(Events.LOADED_DATA, () => {
                    console.log('视频加载成功');
                    this.markStreamReady();
                });

                this.player.on(Events.PLAYING, () => {
                    this.markStreamReady();
                });

                this.player.on(Events.PAUSE, () => {
                    this.playFlag = false;
                });

            } catch (error) {
                console.error('创建播放器失败:', error);
                this.hideVideoLoading();
            }
        },

        // 读取固定播放区域尺寸（优先量外层 .video，统一按 16:9）
        getVideoBoxSize(container) {
            const el = container || document.getElementById('video-container');
            const box = (el && el.parentElement && el.parentElement.classList.contains('video'))
                ? el.parentElement
                : el;
            const width = Math.round(
                (box && (box.clientWidth || box.offsetWidth)) ||
                (el && (el.clientWidth || el.offsetWidth)) ||
                350
            );
            let height = Math.round(
                (box && (box.clientHeight || box.offsetHeight)) ||
                (el && (el.clientHeight || el.offsetHeight)) ||
                0
            );
            if (!height || height < 10) {
                height = Math.round(width * 9 / 16);
            }
            return {
                width: Math.max(width, 1),
                height: Math.max(height, 1)
            };
        },





        // ========== iOS 原生 HLS 播放（Safari 内置解码） ==========
        createNativePlayer(videoUrl, container) {
            const playToken = ++this._nativePlayToken;
            container.innerHTML = '';
            const video = document.createElement('video');
            video.id = 'myPlayer';
            video.className = 'native-video-player';
            video.setAttribute('controls', '');
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.setAttribute('x5-video-player-type', 'h5');
            video.setAttribute('x5-playsinline', '');
            video.setAttribute('preload', 'auto');
            video.style.width = '100%';
            video.style.height = '100%';
            this.nativeVideo = video;

            const onReady = () => {
                if (playToken !== this._nativePlayToken) return;
                this.markStreamReady();
            };
            const hasNativeFrame = () => {
                if (!video || video.error) return false;
                // videoWidth>0 表示已解出首帧，比 playing 更早
                if (video.videoWidth > 0 && video.videoHeight > 0) return true;
                if (video.readyState >= 2) return true;
                if (video.currentTime > 0) return true;
                return false;
            };

            // 必须先绑事件再设 src，否则 iOS 可能漏掉 loadeddata/playing
            ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'timeupdate'].forEach((evt) => {
                video.addEventListener(evt, onReady, { once: true });
            });
            video.addEventListener('pause', () => {
                this.playFlag = false;
            });

            video.addEventListener('error', async () => {
                if (playToken !== this._nativePlayToken) return;
                const errCode = video.error ? video.error.code : 0;
                console.error('原生 HLS 播放失败, code:', errCode, videoUrl);

                // 降级 ezuikit：静默，不立刻弹失败（脚本未就绪时等就绪再建）
                if (this.isIOS && this.isHlsUrl(videoUrl) && !this._ezuikitFallbackTried) {
                    this._ezuikitFallbackTried = true;
                    const url = (this.videoData && this.videoData.platform == 'H5LIV')
                        ? (this.normalizeLiveUrl(this.getLivUrl()) || this.normalizeLiveUrl(videoUrl))
                        : this.normalizeLiveUrl(videoUrl);
                    console.log('原生 HLS 失败，降级 ezuikit-hls:', url);
                    this.clearStreamReadyWatch();
                    this.showVideoLoading();
                    // 只清理原生节点，避免误伤即将创建的 ezuikit
                    try {
                        video.onerror = null;
                        video.removeAttribute('src');
                        video.load();
                        if (video.parentNode) video.parentNode.removeChild(video);
                    } catch (e) { }
                    this.nativeVideo = null;
                    // 确保脚本就绪后再建播放器（解决首次选设备降级失败）
                    await this.loadScript('/static/ezuikit-hls/ezuikit-hls.js').catch(() => {});
                    await this.waitForHlsPlayer(3000);
                    if (playToken !== this._nativePlayToken) return;
                    const ok = await this.loadEzuikitHls(url, this.getVideoBoxSize(container));
                    if (!ok && playToken === this._nativePlayToken) {
                        this.hideVideoLoading();
                        this.$message.error('视频播放失败，请检查网络后重试');
                    }
                    return;
                }

                if (playToken !== this._nativePlayToken) return;
                this.hideVideoLoading();
                this.$message.error('视频播放失败，请检查网络后重试');
            }, { once: true });

            video.src = this.normalizeLiveUrl(videoUrl);
            container.appendChild(video);
            video.load();
            // 首帧回调（支持时比事件更及时）
            if (typeof video.requestVideoFrameCallback === 'function') {
                video.requestVideoFrameCallback(() => onReady());
            }
            video.play().catch((e) => {
                console.log('原生 video 自动播放被阻止，需用户手动点击播放', e);
            });

            // 高频轮询：iOS 原生层常比 HTML 事件更早出画
            this.clearStreamReadyWatch();
            let tries = 0;
            this._streamReadyTimer = setInterval(() => {
                if (playToken !== this._nativePlayToken) {
                    this.clearStreamReadyWatch();
                    return;
                }
                tries += 1;
                if (hasNativeFrame()) {
                    onReady();
                    return;
                }
                if (tries >= 200) {
                    this.clearStreamReadyWatch();
                }
            }, 50);

            console.log('iOS 原生 HLS 播放器创建成功');
        },

        // 等待 ezuikit-hls 全局对象就绪（解决首次选设备脚本未就绪）
        async waitForHlsPlayer(timeoutMs) {
            const deadline = Date.now() + (timeoutMs || 3000);
            while (Date.now() < deadline) {
                const HlsPlayer = window.HlsPlayer || window.EZUIKitPlayerHls || window.EzuikitHls;
                if (HlsPlayer) return HlsPlayer;
                await new Promise(r => setTimeout(r, 50));
            }
            return window.HlsPlayer || window.EZUIKitPlayerHls || window.EzuikitHls || null;
        },

        getEZUIKitPlayerClass() {
            const lib = window.EZUIKit;
            if (!lib) return null;
            if (typeof lib.EZUIKitPlayer === "function") return lib.EZUIKitPlayer;
            if (lib.default && typeof lib.default.EZUIKitPlayer === "function") {
                return lib.default.EZUIKitPlayer;
            }
            return null;
        },

        async waitForEZUIKitPlayer(timeoutMs) {
            const deadline = Date.now() + (timeoutMs || 30000);
            while (Date.now() < deadline) {
                const PlayerClass = this.getEZUIKitPlayerClass();
                if (PlayerClass) return PlayerClass;
                await new Promise(r => setTimeout(r, 100));
            }
            return this.getEZUIKitPlayerClass();
        },

        async preloadEzvizReplayAssets() {
            const src = "/static/ezuikit/ezuikit.js";
            try {
                await this.loadScript(src);
            } catch (e) {
                console.error("加载 EZUIKit 脚本失败:", src, e);
                throw new Error(
                    "回放组件脚本加载失败，请重启 dev 服务或执行 npm install 后重试"
                );
            }
            const PlayerClass = await this.waitForEZUIKitPlayer(30000);
            if (!PlayerClass) {
                throw new Error(
                    "EZUIKit 未就绪，请确认 /static/ezuikit/ezuikit.js 可访问（约 3.8MB，首载较慢）"
                );
            }
        },

        // ========== 预加载播放器静态资源（不改变播放逻辑） ==========
        preloadPlayerAssets() {
            // 后台预加载，失败忽略；首屏起播时可直接用缓存脚本
            this.loadScript('/static/ezuikit-hls/ezuikit-hls.js').catch(() => {});
            this.loadCss('/static/ezuikit-flv/ezuikit-flv.css').catch(() => {});
            this.loadScript('/static/ezuikit-flv/ezuikit-flv.js').catch(() => {});
        },

        // ========== 动态加载脚本 ==========
        loadScript(src) {
            if (!this._scriptPromises) {
                this._scriptPromises = {};
            }
            if (this._scriptPromises[src]) {
                return this._scriptPromises[src];
            }
            this._scriptPromises[src] = new Promise((resolve, reject) => {
                const existing = document.querySelector(`script[src="${src}"]`);
                if (existing) {
                    if (existing.getAttribute('data-loaded') === '1') {
                        resolve();
                        return;
                    }
                    const done = () => {
                        existing.setAttribute('data-loaded', '1');
                        resolve();
                    };
                    existing.addEventListener('load', done, { once: true });
                    existing.addEventListener('error', reject, { once: true });
                    // 缓存命中时部分浏览器不再触发 load
                    if (existing.readyState === 'complete' || existing.readyState === 'loaded') {
                        done();
                    }
                    return;
                }
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => {
                    script.setAttribute('data-loaded', '1');
                    resolve();
                };
                script.onerror = (e) => {
                    delete this._scriptPromises[src];
                    reject(e);
                };
                document.head.appendChild(script);
            });
            return this._scriptPromises[src];
        },

        loadCss(href) {
            if (!this._cssPromises) {
                this._cssPromises = {};
            }
            if (this._cssPromises[href]) {
                return this._cssPromises[href];
            }
            this._cssPromises[href] = new Promise((resolve) => {
                const existing = document.querySelector(`link[href="${href}"]`);
                if (existing) {
                    resolve();
                    return;
                }
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                link.onload = resolve;
                link.onerror = resolve;
                document.head.appendChild(link);
            });
            return this._cssPromises[href];
        },

        // ========== 加载并创建 ezuikit-flv 播放器 ==========
        async loadEzuikitFlv(videoUrl, boxSize) {
            try {
                await Promise.all([
                    this.loadCss('/static/ezuikit-flv/ezuikit-flv.css'),
                    this.loadScript('/static/ezuikit-flv/ezuikit-flv.js')
                ]);
                // 仅在全局未就绪时极短等待，避免固定 100ms
                if (!window.EzuikitFlv) {
                    await new Promise(r => setTimeout(r, 30));
                }
                console.log('脚本加载完成，检查全局变量...');
                console.log('window.EzuikitFlv:', typeof window.EzuikitFlv);
                const relatedKeys = Object.keys(window).filter(k => /ezuikit|flv/i.test(k));
                console.log('相关全局变量:', relatedKeys);
                const size = boxSize || this.getVideoBoxSize();
                if (window.EzuikitFlv) {
                    this.ezuikitFlvPlayer = new window.EzuikitFlv({
                        url: videoUrl,
                        id: 'video-container',
                        decoder: '/static/ezuikit-flv/decoder.js',
                        autoPlay: true,
                        controls: true,
                        width: size.width,
                        height: size.height,
                    });
                    console.log('ezuikit-flv 播放器创建成功', size);
                    this.bindEzuikitStreamReady(this.ezuikitFlvPlayer);
                } else {
                    console.error('EzuikitFlv 全局变量未找到，请检查控制台是否有脚本执行错误');
                    this.hideVideoLoading();
                }
            } catch (error) {
                console.error('ezuikit-flv 加载失败:', error);
                this.hideVideoLoading();
            }
        },

        // ========== 加载并创建 ezuikit-hls 播放器 ==========
        async loadEzuikitHls(videoUrl, boxSize) {
            try {
                await this.loadScript('/static/ezuikit-hls/ezuikit-hls.js');
                // 首次进入时 onload 与 UMD 挂载可能有时差，等待全局就绪
                const HlsPlayer = await this.waitForHlsPlayer(3000);
                const size = boxSize || this.getVideoBoxSize();
                if (HlsPlayer) {
                    const finalUrl = this.normalizeLiveUrl(videoUrl);
                    this.ezuikitHlsPlayer = new HlsPlayer({
                        id: 'video-container',
                        url: finalUrl,
                        staticPath: '/static/ezuikit-hls/',
                        autoPlay: true,
                        controls: true,
                        width: size.width,
                        height: size.height,
                    });
                    console.log('ezuikit-hls 播放器创建成功', size);
                    this.bindEzuikitStreamReady(this.ezuikitHlsPlayer);
                    return true;
                }
                console.error('ezuikit-hls 全局变量未找到，可用的全局变量:', Object.keys(window).filter(k => k.toLowerCase().includes('hls') || k.toLowerCase().includes('ez')));
                this.hideVideoLoading();
                return false;
            } catch (error) {
                console.error('ezuikit-hls 加载失败:', error);
                this.hideVideoLoading();
                return false;
            }
        },

        // ========== 纯萤石云回放：EZUIKit mobileRec ==========
        async loadEzvizReplayPlayer(playUrl, boxSize) {
            try {
                await this.preloadEzvizReplayAssets();
                const PlayerClass = this.getEZUIKitPlayerClass();
                const size = boxSize || this.getVideoBoxSize();
                const accessToken =
                    this.videoData && this.videoData.accessToken
                        ? this.videoData.accessToken
                        : "";
                if (!accessToken) {
                    this.hideVideoLoading();
                    this.$message.error("缺少 accessToken，无法播放回放");
                    return false;
                }
                if (!PlayerClass) {
                    console.error("EZUIKit 未加载，请检查 /static/ezuikit/ezuikit.js");
                    this.hideVideoLoading();
                    this.$message.error("回放组件加载失败，请刷新后重试");
                    return false;
                }
                const url = this.assertEzvizPlaybackUrl(playUrl);
                const self = this;
                this.ezuikitRecPlayer = new PlayerClass({
                    id: "video-container",
                    accessToken,
                    url,
                    template: "mobileRec",
                    width: size.width,
                    height: size.height,
                    staticPath: "/static/ezuikit_static/",
                    scaleMode: 1,
                    autoplay: true,
                    audio: true,
                    playsinline: this.isAppleDevice(),
                    env: { domain: "https://open.ys7.com" },
                    dateOptions: null,
                    ptzOptions: null,
                    talkOptions: null,
                    handleError(err) {
                        console.error("萤石回放播放器错误", err);
                        self.hideVideoLoading();
                        self.$message.error("回放播放失败，请检查录像时段或设备加密设置");
                    }
                });
                console.log("EZUIKit mobileRec 回放创建成功", size);
                this.bindEzuikitStreamReady(this.ezuikitRecPlayer);
                this.scheduleHideVideoLoading(20000);
                return true;
            } catch (error) {
                console.error("萤石回放播放器创建失败", error);
                this.hideVideoLoading();
                this.$message.error(
                    (error && error.message) || "回放播放失败，请稍后重试"
                );
                return false;
            }
        },

        // ========== 处理播放错误 ==========
        handlePlaybackError(videoUrl) {
            if (this.isEzvizCloudReplay()) {
                console.warn("萤石云回放播放错误，不进行 HLS 降级", videoUrl);
                this.hideVideoLoading();
                return;
            }
            console.log('处理播放错误，尝试降级');
            setTimeout(() => {
                this.destroyPlayer();
                const pluginType = this.getBestPlugin();
                this.createPlayer(videoUrl, pluginType);
            }, 1000);
        },

        // ========== 销毁播放器 ==========
        destroyPlayer() {
            this.clearStreamReadyWatch();
            // 使旧原生 video 的 error/playing 回调失效，避免切换设备后误弹失败提示
            this._nativePlayToken++;

            // 销毁 xgplayer
            if (this.player) {
                try {
                    this.player.destroy();
                } catch (e) {
                    console.warn('销毁 xgplayer 失败:', e);
                }
                this.player = null;
            }
            // 销毁 ezuikit-flv
            if (this.ezuikitFlvPlayer) {
                try {
                    this.ezuikitFlvPlayer.destroy();
                } catch (e) {
                    console.warn('销毁 ezuikit-flv 失败:', e);
                }
                this.ezuikitFlvPlayer = null;
            }
            // 销毁 ezuikit-hls
            if (this.ezuikitHlsPlayer) {
                try {
                    this.ezuikitHlsPlayer.destroy();
                } catch (e) {
                    console.warn('销毁 ezuikit-hls 失败:', e);
                }
                this.ezuikitHlsPlayer = null;
            }
            if (this.ezuikitRecPlayer) {
                try {
                    if (typeof this.ezuikitRecPlayer.destroy === "function") {
                        this.ezuikitRecPlayer.destroy();
                    } else if (typeof this.ezuikitRecPlayer.stop === "function") {
                        this.ezuikitRecPlayer.stop();
                    }
                } catch (e) {
                    console.warn("销毁 EZUIKit 回放失败:", e);
                }
                this.ezuikitRecPlayer = null;
            }
            // 清理原生 video
            if (this.nativeVideo) {
                try {
                    this.nativeVideo.pause();
                    this.nativeVideo.src = '';
                    if (this.nativeVideo.parentNode) {
                        this.nativeVideo.parentNode.removeChild(this.nativeVideo);
                    }
                } catch (e) {
                    console.warn('清理原生视频失败:', e);
                }
                this.nativeVideo = null;
            }
            const container = document.getElementById('video-container');
            if (container) {
                container.innerHTML = '';
            }
            if (this.$refs.nativeVideo) {
                try {
                    this.$refs.nativeVideo.pause();
                    this.$refs.nativeVideo.src = '';
                } catch (e) {
                    console.warn('清理模板 video 失败:', e);
                }
            }
        },

        // ========== 登录 ==========
        async loginMain() {
            let username = ''
            let password = ''
            const hash = window.location.hash;
            if (hash.includes('?')) {
                const query = hash.split('?')[1];
                const urlparams = new URLSearchParams(query);
                username = urlparams.get('username') || '';
                password = urlparams.get('password') || '';
            }
            if (!username) username = localStorage.getItem('username');
            if (!password) password = localStorage.getItem('password');

            if (!username || !password) {
                console.error('缺少用户名或密码');
                return;
            }

            // let username = 'admin'
            // let password = 'jstriadmin1970'
            
            // let username = 'lsxj'
            // let password = 'xj_8916'

            try {
                const res = await getLogin({
                    username,
                    password
                });
                if (res.data.code === 0) {
                    window.sessionStorage.setItem("tokenProcedure", res.data.data);
                    this.permission();
                    this.engineerList();
                } else {
                    console.error('登录失败:', res.data.msg);
                    this.$message.error(res.data.msg || '登录失败，请重试');
                }
            } catch (error) {
                this.$message.error('网络错误，请检查网络连接后重试');
            }
        },

        // ========== 获取权限 ==========
        permission() {
            permissionList().then(res => {
                this.serverData = res.data.data;
            });
        },

        // ========== 获取工程 ==========
        engineerList() {
            let params = {};
            getEngineerList(params).then(res => {
                if (res.data.code == 0) {
                    this.engineerListData = res.data.data;
                    this.engineeringId = res.data.data[0].id;
                }
            });
        },

        // ========== 标段 ==========
        sectionList() {
            let params = {
                engineeringId: this.engineeringId
            };
            getSectionList(params).then(res => {
                if (res.data.code == 0) {
                    this.sectionListData = res.data.data;
                    this.sectionId = res.data.data[0].id;
                }
            });
        },

        // ========== 获取视频信息 ==========
        async getImg() {
            this.playbackPickerVisible = false;
            this.showVideoLoading();
            this.hasUrl = false;
            let params = {
                engineeringId: this.engineeringId,
                sectionId: this.sectionId
            };
            const data = await getChannelsList(params);
            this.sideList = data.data.data.map(item => {
                const parentBackUrl = item.backUrl || "";
                item.channelList.map(el => {
                    el.accessToken = item.accessToken;
                    el.name = item.name;
                    el.place = item.place;
                    el.serialNumber = item.serialNumber;
                    el.status = item.status;
                    el.platform = item.platform || el.platform;
                    el.livurl = item.livurl || el.livurl;
                    el.backUrl = el.backUrl || parentBackUrl;
                    return el;
                });
                return item;
            });
            console.log('设备列表:', this.sideList);

            if (this.sideList.length > 0) {
                this.videoData = this.sideList[0].channelList[0];
                this.videoName = '0~0~' + this.videoData.serialNumber + '~' + this.videoData.channelNo;
                this.hasUrl = false;
                this.getFlow(
                    this.videoData.accessToken,
                    this.videoData.serialNumber,
                    this.videoData.channelNo
                );
            } else {
                this.hideVideoLoading();
            }
        },

        // ========== 萤石云直播 HLS（protocol=2，与线上一致） ==========
        async fetchYs7HlsUrl(accessToken, serialNumber, channelNo) {
            const streamQuality =
                Number(this.quality) === 3 ? 1 : Number(this.quality) || 1;
            const data = await this.$http.post(
                `/v2/live/address/get?deviceSerial=${serialNumber}&accessToken=${accessToken}&protocol=${2}&channelNo=${channelNo}&quality=${streamQuality}`
            );
            console.log('data1111111111111111:', data);
            if (data.data.code == 200) {
                return data.data.data.url;
            }
            throw new Error(data.data.msg || '获取 HLS 地址失败');
        },

        // ========== 萤石云回放 m3u8（open.ys7.com /v2/live/address/get） ==========
        async fetchYs7PlaybackUrl(accessToken, serialNumber, channelNo, startTime, stopTime) {
            const streamQuality =
                Number(this.quality) === 3 ? 1 : Number(this.quality) || 1;
            const deviceCode = this.getEzvizDeviceCode();
            const q = [
                `deviceSerial=${encodeURIComponent(serialNumber)}`,
                `accessToken=${encodeURIComponent(accessToken)}`,
                `channelNo=${encodeURIComponent(String(channelNo))}`,
                `startTime=${encodeURIComponent(startTime)}`,
                `stopTime=${encodeURIComponent(stopTime)}`,
                "type=2",
                "protocol=1",
                `quality=${streamQuality}`
            ];
            if (deviceCode) {
                q.push(`code=${encodeURIComponent(deviceCode)}`);
            }
            const data = await this.$http.post(`/v2/live/address/get?${q.join("&")}`);
            const body = data && data.data ? data.data : {};
            const resCode = body.code;
            const ok = resCode == 200 || resCode === "200";
            if (ok && body.data && body.data.url) {
                return this.assertEzvizPlaybackUrl(body.data.url);
            }
            throw new Error(body.msg || "获取回放地址失败");
        },

        // ========== 启动播放 ==========
        startPlayback(videoUrl) {
            this.videoData.videoUrl = videoUrl;
            this.playFlag = true;
            // loading 由 getFlow 开始时计时，最多 1 秒；这里不再重置，避免出画后仍长时间显示

            const pluginType = this.getBestPlugin();
            console.log('使用播放方式:', pluginType);
            console.log('视频 URL:', videoUrl);
            if (pluginType === "ezuikitRec") {
                this.scheduleHideVideoLoading(20000);
            }

            // 去掉 nextTick + rAF + 50ms 固定等待，容器已在时立刻起播
            const start = () => {
                const container = document.getElementById('video-container');
                if (!container) {
                    console.error('视频容器不存在');
                    this.hideVideoLoading();
                    return;
                }
                this.createPlayer(videoUrl, pluginType);
                this.hasUrl = true;
            };

            if (document.getElementById('video-container')) {
                start();
            } else {
                this.$nextTick(start);
            }
        },

        // ========== loading 控制 ==========
        showVideoLoading() {
            this.isVideoLoading = true;
            this.clearStreamReadyWatch();
            // 开始取流后最多显示约 1 秒，避免出画后仍长时间挡着
            this.scheduleHideVideoLoading(1000);
        },
        hideVideoLoading() {
            this.isVideoLoading = false;
            this.clearStreamReadyWatch();
            if (this._loadingTimer) {
                clearTimeout(this._loadingTimer);
                this._loadingTimer = null;
            }
        },
        // 取流成功后关闭 loading
        markStreamReady() {
            this.playFlag = true;
            this.hideVideoLoading();
        },
        clearStreamReadyWatch() {
            if (this._streamReadyTimer) {
                clearInterval(this._streamReadyTimer);
                this._streamReadyTimer = null;
            }
        },
        // ezuikit 无统一起播事件时，监听容器内媒体就绪（可提前关 loading）
        bindEzuikitStreamReady(player) {
            this.clearStreamReadyWatch();

            const tryBind = (evt) => {
                if (!player) return;
                const handler = () => this.markStreamReady();
                if (typeof player.on === 'function') {
                    player.on(evt, handler);
                    return true;
                }
                if (typeof player.addEventListener === 'function') {
                    player.addEventListener(evt, handler);
                    return true;
                }
                return false;
            };

            ['playing', 'play', 'loadeddata', 'canplay', 'firstFrame', 'videoInfo'].forEach(tryBind);

            const hasFrame = (container) => {
                const video = container.querySelector('video');
                if (video && !video.error) {
                    if (video.videoWidth > 0 && video.videoHeight > 0) return true;
                    if (video.readyState >= 2 || video.currentTime > 0) return true;
                }
                const canvas = container.querySelector('canvas');
                if (canvas && canvas.width > 0 && canvas.height > 0) return true;
                return false;
            };

            let tries = 0;
            this._streamReadyTimer = setInterval(() => {
                tries += 1;
                const container = document.getElementById('video-container');
                if (!container) return;
                if (hasFrame(container)) {
                    this.markStreamReady();
                    return;
                }
                if (tries >= 40) {
                    this.clearStreamReadyWatch();
                }
            }, 50);
            // 不再用超长超时；上限由 showVideoLoading 的 1s 控制
        },
        scheduleHideVideoLoading(delay) {
            if (this._loadingTimer) {
                clearTimeout(this._loadingTimer);
            }
            const ms = delay == null ? 1000 : delay;
            this._loadingTimer = setTimeout(() => {
                this.isVideoLoading = false;
                this._loadingTimer = null;
                this.clearStreamReadyWatch();
            }, ms);
        },

        // ========== 统一播放/暂停（覆盖各播放器差异） ==========
        togglePlayPause() {
            if (this.playFlag) {
                this.pausePlayback();
                this.playFlag = false;
            } else {
                this.resumePlayback();
            }
        },
        pausePlayback() {
            try {
                if (this.player && typeof this.player.pause === 'function') {
                    this.player.pause();
                    return;
                }
                if (this.nativeVideo) {
                    this.nativeVideo.pause();
                    return;
                }
                if (this.ezuikitFlvPlayer) {
                    if (typeof this.ezuikitFlvPlayer.pause === 'function') {
                        this.ezuikitFlvPlayer.pause();
                    } else if (typeof this.ezuikitFlvPlayer.stop === 'function') {
                        this.ezuikitFlvPlayer.stop();
                    }
                    return;
                }
                if (this.ezuikitHlsPlayer) {
                    if (typeof this.ezuikitHlsPlayer.pause === 'function') {
                        this.ezuikitHlsPlayer.pause();
                    } else if (typeof this.ezuikitHlsPlayer.stop === 'function') {
                        this.ezuikitHlsPlayer.stop();
                    }
                    return;
                }
                if (this.ezuikitRecPlayer) {
                    if (typeof this.ezuikitRecPlayer.pause === "function") {
                        this.ezuikitRecPlayer.pause();
                    } else if (typeof this.ezuikitRecPlayer.stop === "function") {
                        this.ezuikitRecPlayer.stop();
                    }
                }
            } catch (e) {
                console.warn('暂停失败:', e);
            }
        },
        resumePlayback() {
            this.showVideoLoading();
            this.playFlag = true;
            try {
                if (this.player && typeof this.player.play === 'function') {
                    Promise.resolve(this.player.play()).catch(() => {});
                    this.scheduleHideVideoLoading(1000);
                    return;
                }
                if (this.nativeVideo) {
                    this.nativeVideo.play().then(() => {
                        // playing 事件会 markStreamReady；这里不提前关
                    }).catch(() => {
                        this.hideVideoLoading();
                    });
                    this.scheduleHideVideoLoading(1000);
                    return;
                }
                if (this.ezuikitFlvPlayer && typeof this.ezuikitFlvPlayer.play === 'function') {
                    this.ezuikitFlvPlayer.play();
                    this.bindEzuikitStreamReady(this.ezuikitFlvPlayer);
                    return;
                }
                if (this.ezuikitHlsPlayer && typeof this.ezuikitHlsPlayer.play === 'function') {
                    this.ezuikitHlsPlayer.play();
                    this.bindEzuikitStreamReady(this.ezuikitHlsPlayer);
                    return;
                }
                if (this.ezuikitRecPlayer) {
                    if (typeof this.ezuikitRecPlayer.play === "function") {
                        this.ezuikitRecPlayer.play();
                        this.bindEzuikitStreamReady(this.ezuikitRecPlayer);
                        return;
                    }
                    if (
                        typeof this.ezuikitRecPlayer.changePlayUrl === "function" &&
                        this.videoData &&
                        this.videoData.videoUrl
                    ) {
                        this.ezuikitRecPlayer.changePlayUrl({
                            url: this.videoData.videoUrl
                        });
                        this.bindEzuikitStreamReady(this.ezuikitRecPlayer);
                        return;
                    }
                }
                // 部分播放器 pause/stop 后需重新拉流
                if (this.videoData && this.videoData.accessToken) {
                    if (
                        Number(this.quality) === 3 &&
                        this.videoData.platform !== 'H5LIV'
                    ) {
                        this.fetchPlaybackStream();
                    } else {
                        this.getFlow(
                            this.videoData.accessToken,
                            this.videoData.serialNumber,
                            this.videoData.channelNo
                        );
                    }
                    return;
                }
                this.hideVideoLoading();
            } catch (e) {
                console.warn('恢复播放失败:', e);
                this.hideVideoLoading();
            }
        },

        // ========== 获取直播URL ==========
        async getFlow(accessToken, serialNumber, channelNo) {
            this.showVideoLoading();
            this.hasUrl = false;
            this.playFlag = true;

            // 取流同时预热脚本；先销毁旧播放器释放解码资源
            this.preloadPlayerAssets();
            this.destroyPlayer();

            this._flowParams = { accessToken, serialNumber, channelNo };
            this._ezuikitFallbackTried = false;

            try {
                let videoUrl;

                if (this.videoData.platform == 'H5LIV') {
                    // H5LIV 回放暂时关闭，统一走直播地址
                    // if (Number(this.quality) === 3) {
                    //     const backUrl = this.normalizeLiveUrl(this.getBackUrl());
                    //     if (!backUrl) {
                    //         throw new Error('缺少回放地址 backUrl');
                    //     }
                    //     videoUrl = backUrl;
                    // } else {
                    if (Number(this.quality) === 3) {
                        this.quality = 1;
                    }
                    const livurl = this.normalizeLiveUrl(this.getLivUrl());
                    if (!livurl) {
                        throw new Error('缺少直播地址 livurl');
                    }
                    videoUrl = livurl;
                    // }
                } else if (Number(this.quality) === 3) {
                    if (!this.startTime || !this.stopTime) {
                        throw new Error('请先选择回放时间范围');
                    }
                    videoUrl = await this.fetchYs7PlaybackUrl(
                        accessToken,
                        serialNumber,
                        channelNo,
                        this.startTime,
                        this.stopTime
                    );
                } else {
                    videoUrl = await this.fetchYs7HlsUrl(accessToken, serialNumber, channelNo);
                }

                const isEzvizReplay =
                    Number(this.quality) === 3 &&
                    this.videoData.platform !== "H5LIV";
                if (isEzvizReplay) {
                    await this.preloadEzvizReplayAssets();
                } else {
                    const needEzuikit =
                        this.isIOS && !this.isLowVersionIOS();
                    if (needEzuikit) {
                        await this.loadScript('/static/ezuikit-hls/ezuikit-hls.js').catch(() => {});
                        await this.waitForHlsPlayer(2000);
                    }
                }

                this.startPlayback(videoUrl);
            } catch (error) {
                console.error('获取视频流失败:', error);
                this.hasUrl = false;
                this.hideVideoLoading();
                this.destroyPlayer();
                const msg = error && error.message ? error.message : '获取视频流失败，请检查网络！';
                this.$message.error(msg);
            }
        },

        // ========== 切换视频 ==========
        changeVideo(val) {
            this.getcontrolEnd();
            let parts = val.split('~')
            let itemChildIndex = parseInt(parts[0])
            let childIndex = parseInt(parts[1])
            let serialNumber = parts[2]
            let channelNo = parts[3]

            if (this.sideList[itemChildIndex] && this.sideList[itemChildIndex].channelList[childIndex]) {
                this.videoData = this.sideList[itemChildIndex].channelList[childIndex]
            } else {
                let arr = this.sideList.filter(item => {
                    return item.serialNumber == serialNumber
                })[0]
                this.videoData = arr.channelList.filter(item => {
                    return item.channelNo == channelNo
                })[0]
            }

            this.showVideoLoading();
            this.hasUrl = false;
            this.getFlow(
                this.videoData.accessToken,
                serialNumber,
                channelNo
            );
        },

        // ========== 选择清晰度 / 回放 ==========
        changeQuality(val) {
            const prevQuality = this.quality;
            const platform = this.videoData ? this.videoData.platform : "";

            if (val === 3 && platform === "H5LIV") {
                // H5LIV 回放暂时关闭
                // this.startH5LivPlayback();
                return;
            }

            if (val === 3) {
                this.openPlaybackPicker();
                if (Number(prevQuality) !== 3) {
                    return;
                }
                return;
            }

            this.quality = val;
            this.showVideoLoading();
            this.hasUrl = false;
            this.getFlow(
                this.videoData.accessToken,
                this.videoData.serialNumber,
                this.videoData.channelNo
            );
        },

        // ========== 镜头控制 ==========
        controlDirection(item) {
            if (this.nowStop == false && this.canStop == false) {
                this.direction = item;
                let params = {
                    deviceSerial: this.videoData.serialNumber,
                    accessToken: this.videoData.accessToken,
                    channelNo: this.videoData.channelNo,
                    speed: 1,
                    direction: this.direction
                };
                controlStart(params).then(res => {
                    if (res.data == "success") {
                        this.canStop = true;
                    } else {
                        this.canStop = false;
                    }
                });
            } else {
                this.$message.error("点击过于频繁，请稍后再试！");
                return;
            }
        },

        // ========== 停止 ==========
        stopDirection() {
            this.nowStop = true;
        },

        // ========== 停止接口 ==========
        getcontrolEnd() {
            let params = {
                deviceSerial: this.videoData.serialNumber,
                accessToken: this.videoData.accessToken,
                channelNo: this.videoData.channelNo,
                speed: 1,
                direction: this.direction
            };
            controlEnd(params).then(res => {
                if (res.data == "success") {
                    this.canStop = false;
                    this.nowStop = false;
                } else {
                    this.getcontrolEnd();
                }
            });
        },

        controlButton() {
            if (this.controlFlag) {
                this.controlFlag = false;
                this.controlMaxFlag = false;
                this.controlButtonFlag = false;
            } else {
                this.controlFlag = true;
                if (this.fullFlag) {
                    this.controlMaxFlag = true;
                } else {
                    this.controlButtonFlag = true;
                }
            }
        }
    },
    beforeDestroy() {
        this.unlockPageScroll();
        this.destroyPlayer();
    }
};



// WEBPACK FOOTER //
// ./src/view/yeMast/yeMast_index.js